/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Faq_Q2_AnswerInputs */

const en_faq_q2_answer = /** @type {(inputs: Faq_Q2_AnswerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your policy number can be found on your policy confirmation documents which was emailed to you by your insurance agent or ${i?.companyName}.`)
};

const fr_faq_q2_answer = /** @type {(inputs: Faq_Q2_AnswerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre numéro de police se trouve dans les documents de confirmation de police qui vous ont été envoyés par courriel par votre agent d'assurance ou ${i?.companyName}.`)
};

/**
* | output |
* | --- |
* | "Your policy number can be found on your policy confirmation documents which was emailed to you by your insurance agent or {companyName}." |
*
* @param {Faq_Q2_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_q2_answer = /** @type {((inputs: Faq_Q2_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q2_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q2_answer(inputs)
	return fr_faq_q2_answer(inputs)
});